var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUserProfileOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.75 1.5C6.70445 1.5 5.017 3.20594 5.017 5.267C5.017 7.32068 6.6971 9 8.75 9C10.7956 9 12.483 7.29406 12.483 5.233C12.483 3.17932 10.8029 1.5 8.75 1.5ZM3.517 5.267C3.517 2.39206 5.86155 0 8.75 0C11.6311 0 13.983 2.35068 13.983 5.233C13.983 8.10794 11.6384 10.5 8.75 10.5C5.8689 10.5 3.517 8.14932 3.517 5.267ZM4.75 13.5C2.96421 13.5 1.5 14.9642 1.5 16.75V17.75C1.5 17.8858 1.61421 18 1.75 18H15.75C15.8858 18 16 17.8858 16 17.75V16.75C16 14.9642 14.5358 13.5 12.75 13.5H4.75ZM0 16.75C0 14.1358 2.13579 12 4.75 12H12.75C15.3642 12 17.5 14.1358 17.5 16.75V17.75C17.5 18.7142 16.7142 19.5 15.75 19.5H1.75C0.785786 19.5 0 18.7142 0 17.75V16.75Z",
    fill: "#D8DFEA"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfileOutline);
export default __webpack_public_path__ + "static/media/user-profile-outline.dec58464007c149bb85ef345474acc71.svg";
export { ForwardRef as ReactComponent };